<template>
  <div class="rule-config-page">
    <el-alert
      class="rule-summary"
      :title="ruleSummary"
      type="info"
      :closable="false"
    />

    <el-table
      ref="ruleTable"
      v-loading="loading"
      :data="rows"
      :height="maxTableHeight - 60"
      border
      size="small"
      :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      element-loading-text="数据加载中"
    >
      <el-table-column
        v-for="column in columns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :min-width="column.width || 120"
        show-overflow-tooltip
      />
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="detailLoading || dictLoading || !dictReady"
            @click="edit(scope.row)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="period-pagination"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total"
      :page-sizes="[10, 30, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="search"
      @current-change="load"
    />

    <el-dialog
      v-if="visible"
      title="编辑基础发货周期规则"
      :visible.sync="visible"
      width="1100px"
      :close-on-click-modal="false"
      :show-close="!saving"
      :close-on-press-escape="!saving"
    >
      <div class="period-readonly">
        {{ form.className }} / {{ form.productionLogisticsTypeName }} / {{ form.supplyChannelName }} / {{ form.priorityCode }}
      </div>
      <el-table
        :data="form.nodes"
        border
        size="small"
        class="detail-block"
        empty-text="该规则没有判断节点"
      >
        <el-table-column label="节点关系" width="115">
          <template slot-scope="scope">
            <span v-if="scope.$index === 0">—</span>
            <el-select
              v-else
              v-model="scope.row.logicConnector"
              :disabled="saving"
            >
              <el-option label="且" value="AND" />
              <el-option label="或" value="OR" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="判断字段" min-width="250">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.fieldCode"
              filterable
              style="width: 100%"
              :disabled="saving"
            >
              <el-option
                v-for="item in dict.fieldOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="判断符号" width="115">
          <template slot-scope="scope">
            <el-select v-model="scope.row.judgmentSymbol" :disabled="saving">
              <el-option
                v-for="item in dict.operatorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="判断数值" width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.judgmentValue"
              :controls="false"
              :disabled="saving"
              style="width: 125px"
            />
          </template>
        </el-table-column>
        <el-table-column label="单位" width="155">
          <template slot-scope="scope">
            <el-select v-model="scope.row.unit" :disabled="saving">
              <el-option
                v-for="item in dict.unitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
      </el-table>

      <el-form inline size="small" class="detail-block" :disabled="saving">
        <el-form-item label="结果类型" required>
          <el-select v-model="form.resultType">
            <el-option
              v-for="item in dict.resultTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.resultType === 'FIXED'" label="周期（天）" required>
          <el-input-number
            v-model="form.resultValue"
            :min="1"
            :precision="0"
            :controls="false"
          />
        </el-form-item>
        <el-form-item v-else label="结果来源" required>
          <el-select v-model="form.resultSourceField">
            <el-option
              v-for="item in dict.sourceFieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <p>原始判断逻辑（只读）</p>
      <div class="period-readonly">
        {{ form.logicText || form.ruleDesc || '—' }}
      </div>
      <p>系统计算公式（只读）</p>
      <div class="period-readonly">
        {{ form.formulaDesc || '—' }}
      </div>
      <p>
        规则版本：{{ form.ruleVersion }} / 更新人：{{ form.operatorName }} /
        更新时间：{{ form.updatedTime }}
      </p>
      <el-alert v-if="editError" :title="editError" type="error" :closable="false" />
      <span slot="footer">
        <el-button :disabled="saving" @click="visible = false">
          取消
        </el-button>
        <el-button type="primary" :loading="saving" @click="save">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ruleConfigMixin from './ruleConfig.mixin'

export default {
  name: 'BasicRuleConfig',
  mixins: [ruleConfigMixin],
  data () {
    return {
      configType: 'BASIC',
      resultColumnLabel: '最终发货周期'
    }
  }
}
</script>

<style scoped>
.rule-summary {
  margin-bottom: 16px;
}

.detail-block {
  margin-top: 16px;
}
</style>
